/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Actions/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import CancelAction from './CancelAction/index'
import ConfirmAction from './ConfirmAction/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Actions({
  children,
  viewPath = "/DesignSystem/TysiaInputDateRange/TysiaDateRange/Actions",
  closePopover,
  onSave,
  currentValue
  
}) {
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
  return (<React.Fragment
>
<div
  data-testid="Actions.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-AjnkD': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--mr-2-AjnkD': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--mb-3-AjnkD': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs}}
 className={`views-block ${styles.Horizontal}`}
>
<CancelAction
  viewPath={`${viewPath}/CancelAction`}
 closePopover={closePopover}
/>
<ConfirmAction
  viewPath={`${viewPath}/ConfirmAction`}
 closePopover={closePopover}
 onSave={onSave}
 currentValue={currentValue}
/>
</div>
{children}
</React.Fragment>)
}